import { Identifiable, List } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isTaskFiltered } from "../tasks";
import { isMilestoneFiltered } from "../milestones";
import { isEventFiltered } from "../events";
import { isFilteredByProjectsElementsTags } from "./projectsElementsTags";

function isListFiltered(list: Identifiable<List>, filter: Filter): boolean {
  const areTasksFiltered = list.tasks.every((task) =>
    isTaskFiltered(task, filter),
  );
  const areEventsFiltered =
    !areTasksFiltered ||
    list.events.every((event) => isEventFiltered(event, filter));
  const areMilestonesFiltered =
    !areTasksFiltered ||
    !areEventsFiltered ||
    list.milestones.every((milestone) =>
      isMilestoneFiltered(milestone, filter),
    );
  const areSubListListsFiltered =
    !areTasksFiltered ||
    !areEventsFiltered ||
    !areMilestonesFiltered ||
    list.subLists.every((subList) => isListFiltered(subList, filter));
  const childrenFilters = [
    ...(list.tasks.length > 0 ? [areTasksFiltered] : []),
    ...(list.events.length > 0 ? [areEventsFiltered] : []),
    ...(list.milestones.length > 0 ? [areMilestonesFiltered] : []),
    ...(list.subLists.length > 0 ? [areSubListListsFiltered] : []),
  ];
  const isFiltered = [isFilteredByProjectsElementsTags].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(list, filter),
    false,
  );
  const hasAppliedListFilter =
    "projectsElementsTags" in filter &&
    !!filter.projectsElementsTags &&
    filter.projectsElementsTags.length > 0;

  return (
    (hasAppliedListFilter &&
      isFiltered &&
      childrenFilters.flat().every((isFiltered) => isFiltered, true)) ||
    childrenFilters.reduce(
      (acc, isFiltered) => acc && isFiltered,
      childrenFilters.length > 0,
    )
  );
}

export { isListFiltered };
